var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",on:{"click":_vm.click}},[_vm._v("twitterユーザーの小説を読み込む")])}
var staticRenderFns = []

export { render, staticRenderFns }